import CreateWindow from "../puzzleWindow";
import "./index.css";
import { html, render } from "lit-html";
import kirjainkiekko from "./kirjainkiekko.jpg";
import consoleOpen from "./H1_lukkokonsoli_2D_auki.png";
import consoleClosed from "./H1_lukkokonsoli_2D_kiinni.png";
import imagesLoaded from "imagesloaded";
import { tips } from "~src/tips/index.js";
import { mobileOrNot } from "~/src/helpers/mobileDetect.js";
import { exitButtonPosition } from "../../helpers/exitButtonPosition"

export const lockConsoleImages = [consoleOpen, consoleClosed]

let downEvent = mobileOrNot() ? "touchstart" : "mousedown";
let upEvent = mobileOrNot() ? "touchend" : "mouseup";
let inputWord = "pdoleh".split(""); // melonj , vgidou

let characters = "abcdefghijklmnopqrstuvwxyzåäö".split("");
let clearFunction = () => null;
let puzzleSolved = false;
let doorOpened;
let closeModalAndOpenDoorCallback;

let rolls = 0;

let consoleBackground = consoleClosed;

const middlePoints = (() => {
  let data = [];
  let runningValue = 62; // This gives us "A"

  for (let i = 0; i < characters.length; i++) {
    let middle = runningValue;
    data.push({
      start: middle - 18.4,
      middle: middle,
      end: middle + 18.4,
      character: characters[i],
    });
    runningValue = runningValue + 39.9;
  }

  return data;
})();

let interval;
const singleDisc = (index) => {
  let percent = middlePoints.find((e) => e.character === inputWord[index - 1])
    .middle;

  let transition;

  let rollToNearest;
  let cursor;
  const checkLimits = () => {
    let isOver;
    cursor = "pointer";
    if (percent <= 62) {
      cursor = "not-allowed";
      percent = 62;
      isOver = true;
    }
    if (percent >= 1179) {
      cursor = "not-allowed";
      percent = 1179;
      isOver = true;
    }
    return isOver;
  };

  const checkWhichNumber = (val) => {
    return middlePoints.find((e) => val >= e.start && val <= e.end);
  };

  const moveByStep = (event, direction) => {
    if (puzzleSolved) {
      cursor = "not-allowed";
      return;
    }
    //if (!mobileOrNot() && !detectLeftButton(event)) return;
    console.log("asdgasdg");
    event.stopPropagation();
    if (direction === "up") {
      percent = percent - 39.9;
    } else if (direction === "down") {
      percent = percent + 39.9;
    }
    if (!checkLimits()) {
      // this is run if it is possible to move the disc, so playing sound
      window.scene.getSoundByName("switchOpens")?.play();
    }
    checkLimits();
    const d = checkWhichNumber(percent);
    if (!d) return null;
    inputWord[index - 1] = d.character;
    console.log(inputWord);
    transition = "all 0.1s ease-out";
    if (inputWord.join("") === "meloni") {
      consoleBackground = consoleOpen;
      closeModalAndOpenDoorCallback();
      puzzleSolved = true;
    } else {
      consoleBackground = consoleClosed;
    }
    consoleLockPuzzle();
  };

  return {
    html: () => html`<div id="slider-${index}" class="letter-slider">
      <div class="visible-part">
        <img
          src=${kirjainkiekko}
          style="bottom: ${percent}%; transition: ${transition}; pointer-events: none;"
        />
      </div>
      <div class="shadowed-up"></div>
      <div class="target"></div>

      <div class="shadowed-down"></div>
      <div
        class="up-arrow"
        style="cursor: ${cursor}"
        @click=${(event) => moveByStep(event, "up")}
      ></div>
      <div
        style="cursor: ${cursor}"
        class="down-arrow"
        @click=${(event) => moveByStep(event, "down")}
      ></div>
    </div>`,
  };
};

const firstDisc = singleDisc(1).html;
const secondDisc = singleDisc(2).html;
const thirdDisc = singleDisc(3).html;
const fourthDisc = singleDisc(4).html;
const fifthDisc = singleDisc(5).html;
const sixthDisc = singleDisc(6).html;

let puzzleWindow, closeModal;
let modalMouseUpListener;
let allImagesLoaded = false;

const consoleLockPuzzle = function (doorTrigger) {
  if (!closeModalAndOpenDoorCallback) {
    closeModalAndOpenDoorCallback = () => {
      window.setTimeout(() => {
        if (puzzleWindow && puzzleWindow.exit) {
          puzzleWindow.exit(null, { removeContainer: true });
          //setTimeout("#modal")
        }
        if (doorTrigger && !doorOpened) {
          doorOpened = true;
          puzzleWindow = false;
          doorTrigger();
          clearTimeout(closeModalAndOpenDoorCallback);
        }
      }, 2000);
    };
  }

  const markup = () => html`
    <div id="consoleLock">
      ${!allImagesLoaded
        ? html`<div id="fake-images" style="display: none">
              <img
                src=${consoleOpen}
                style="width: 0; height: 0; pointer-events:'none';"
              />
              <img
                src=${consoleClosed}
                style="width: 0; height: 0; pointer-events:'none';"
              />
            </div>
            <div id="loading">LADATAAN</div>`
        : html``}
      <img src=${consoleBackground} id="console-background" />
      ${firstDisc()} ${secondDisc()} ${thirdDisc()} ${fourthDisc()}
      ${fifthDisc()} ${sixthDisc()}
    </div>
  `;

  if (!puzzleWindow)
    puzzleWindow = CreateWindow({
      removeContainer: true,
      exitCallback: () => {
        document
          .getElementById("modal-container")
          .removeEventListener(upEvent, clearFunction);
        puzzleWindow = null;
        tips.solveLockConsole.setTime(20);
      },
    });
  render(markup(), puzzleWindow.element);

  if (!allImagesLoaded) {
    imagesLoaded("#consoleLock", function () {
      allImagesLoaded = true;
      render(markup(), puzzleWindow.element);
    });
  }

  document
    .getElementById("modal-container")
    .removeEventListener(upEvent, clearFunction);

  document
    .getElementById("modal-container")
    .addEventListener(upEvent, clearFunction);


  exitButtonPosition();

  };

export default consoleLockPuzzle;
